import * as React from 'react';
import { useAppSelector } from '../../../../../../hooks/useAppSelector';
import { selectCartIsActive } from '../../../../../../modules/selectors';
import { RemoveButton } from '../../../../../RemoveButton';
import { Price } from './Price';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
var styles = {
  "root": "FooterRow-root_2Wif3",
  "trashButton": "FooterRow-trashButton_Kw4kl"
};
export function FooterRow({
  handleRemoveAction,
  price
}) {
  const active = useAppSelector(selectCartIsActive);
  return /*#__PURE__*/_jsxs("div", {
    className: styles.root,
    children: [active && /*#__PURE__*/_jsx(RemoveButton, {
      className: styles.trashButton,
      handleRemoveAction: handleRemoveAction,
      small: true
    }), /*#__PURE__*/_jsx(Price, {
      price: price
    })]
  });
}